<template lang="pug">
nav.edital-navbar
  .edital-navbar__container
    .edital-navbar__desktop
      a.edital-navbar__logo-link(:href="portalHomeUrl")
        img.edital-navbar__logo(
          src="@/assets/icons/editais/nav-logo.svg"
          alt="SICARF"
        )

      .edital-navbar__links
        a.edital-navbar__link(:href="portalHomeUrl") Início

        .edital-navbar__dropdown
          .edital-navbar__dropdown-trigger
            span Consultas
            svg.edital-navbar__chevron(
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            )
              path(
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              )

          .edital-navbar__dropdown-panel
            .edital-navbar__dropdown-menu
              a.edital-navbar__dropdown-link(
                v-for="item in consultasLinks"
                :key="item.label"
                :href="item.href"
                :target="item.external ? '_blank' : null"
                :rel="item.external ? 'noopener noreferrer' : null"
              ) {{ item.label }}

        a.edital-navbar__link(
          v-for="item in navLinks"
          :key="item.label"
          :href="item.href"
        ) {{ item.label }}

        a.edital-navbar__link(:href="credenciadosUrl") Credenciados

        a.edital-navbar__link(
          :href="credenciamentoUrl"
          :class="{ 'edital-navbar__link--active': isCredenciamentoAtivo }"
          :aria-current="isCredenciamentoAtivo ? 'page' : null"
        ) Seja um Credenciado

      a.edital-navbar__login-link(:href="loginUrl")
        button.edital-navbar__login(type="button") Login

    .edital-navbar__mobile
      a.edital-navbar__logo-link(:href="portalHomeUrl")
        img.edital-navbar__logo(
          src="@/assets/icons/editais/nav-logo.svg"
          alt="SICARF"
        )

      button.edital-navbar__menu-toggle(
        type="button"
        aria-label="Abrir menu"
        @click="toggleMobileMenu"
      )
        svg(
          width="35"
          height="35"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        )
          path(
            d="M4 7H20M4 12H20M4 17H20"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          )

      .edital-navbar__mobile-overlay(
        :class="{ 'edital-navbar__mobile-overlay--open': isMobileMenuOpen }"
        @click="closeMobileMenu"
      )

      .edital-navbar__mobile-panel(
        :class="{ 'edital-navbar__mobile-panel--open': isMobileMenuOpen }"
      )
        .edital-navbar__mobile-links
          a.edital-navbar__mobile-link(:href="portalHomeUrl" @click="closeMobileMenu") Início

          a.edital-navbar__mobile-link(
            v-for="item in consultasLinks"
            :key="`mobile-${item.label}`"
            :href="item.href"
            :target="item.external ? '_blank' : null"
            :rel="item.external ? 'noopener noreferrer' : null"
            @click="closeMobileMenu"
          ) {{ item.label }}

          a.edital-navbar__mobile-link(
            v-for="item in navLinks"
            :key="`mobile-${item.label}`"
            :href="item.href"
            @click="closeMobileMenu"
          ) {{ item.label }}

          a.edital-navbar__mobile-link(
            :href="credenciadosUrl"
            @click="closeMobileMenu"
          ) Credenciados

          a.edital-navbar__mobile-link(
            :href="credenciamentoUrl"
            :class="{ 'edital-navbar__mobile-link--active': isCredenciamentoAtivo }"
            :aria-current="isCredenciamentoAtivo ? 'page' : null"
            @click="closeMobileMenu"
          ) Seja um Credenciado

        a.edital-navbar__mobile-login-link(:href="loginUrl" @click="closeMobileMenu")
          button.edital-navbar__mobile-login(type="button") Login
</template>

<script>
import { NAVBAR_CONSULTAS, NAVBAR_LINKS } from '@/constants/editaisPublico'

export default {
  name: 'EditalNavbar',
  data () {
    return {
      isMobileMenuOpen: false
    }
  },
  computed: {
    urlPortal () {
      return (process.env.VUE_APP_ROOT_PARAMETRIZAVEL_URL || '').replace(/\/$/, '')
    },
    portalHomeUrl () {
      return this.urlPortal
    },
    consultasLinks () {
      return NAVBAR_CONSULTAS.map(item => ({
        label: item.label,
        href: item.href || `${this.urlPortal}${item.path}`,
        external: !!item.external
      }))
    },
    navLinks () {
      return NAVBAR_LINKS
        .filter(item => item.label !== 'Início')
        .map(item => ({
          label: item.label,
          href: `${this.urlPortal}${item.path}`
        }))
    },
    credenciadosUrl () {
      return `${this.urlPortal}/credenciados`
    },
    credenciamentoUrl () {
      return '#/editais'
    },
    isCredenciamentoAtivo () {
      const rotasCredenciamento = [
        'editais',
        'credenciados/cadastro',
        'credenciados/cadastro/formulario',
        'credenciados/cadastro/confirmacao'
      ]
      return rotasCredenciamento.includes(this.$route.name)
    },
    loginUrl () {
      return `${process.env.VUE_APP_SICARF_URL}/#/login`
    }
  },
  methods: {
    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu () {
      this.isMobileMenuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
$navbar-primary: #1e174e;
$navbar-secondary: #18c5c2;
$navbar-texts: #374151;

.edital-navbar {
  background-color: $navbar-primary;
  font-family: 'Ubuntu', sans-serif;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.75rem;
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
  position: relative;
  width: 100%;
  z-index: 100;
}

.edital-navbar__container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
}

.edital-navbar__desktop {
  align-items: center;
  display: none;
  justify-content: space-between;
}

.edital-navbar__logo-link {
  display: inline-flex;
  flex-shrink: 0;
  text-decoration: none;
}

.edital-navbar__logo {
  display: block;
  height: auto;
  width: 150px;
}

.edital-navbar__links {
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.edital-navbar__link {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  padding: 0;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover,
  &--active {
    color: $navbar-secondary;
  }
}

.edital-navbar__dropdown {
  cursor: pointer;
  position: relative;
  z-index: 100;

  &:hover .edital-navbar__dropdown-trigger,
  &:focus-within .edital-navbar__dropdown-trigger {
    color: $navbar-secondary;
  }

  &:hover .edital-navbar__dropdown-panel,
  &:focus-within .edital-navbar__dropdown-panel {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
}

.edital-navbar__dropdown-trigger {
  align-items: center;
  color: inherit;
  display: flex;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  gap: 0.25rem;
  line-height: inherit;
  transition: all 0.2s ease;
}

.edital-navbar__chevron {
  display: block;
  flex-shrink: 0;
}

.edital-navbar__dropdown-panel {
  left: 0;
  opacity: 0;
  padding-top: 0.5rem;
  pointer-events: none;
  position: absolute;
  top: 100%;
  transform: translateY(-0.5rem);
  transition: all 0.2s ease;
  width: fit-content;
}

.edital-navbar__dropdown-menu {
  background-color: #ffffff;
  border-radius: 0.375rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  color: $navbar-texts;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  white-space: nowrap;
}

.edital-navbar__dropdown-link {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: $navbar-secondary;
  }
}

.edital-navbar__login-link {
  flex-shrink: 0;
  text-decoration: none;
}

.edital-navbar__login {
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  padding: 0.5rem 3rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
    transform: translateY(-0.25rem);
  }
}

.edital-navbar__mobile {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.edital-navbar__menu-toggle {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  filter: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.2));
  padding: 0;
}

.edital-navbar__mobile-overlay {
  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.1);
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.2s ease;
  z-index: 100;

  &--open {
    opacity: 1;
    pointer-events: auto;
  }
}

.edital-navbar__mobile-panel {
  background-color: #ffffff;
  bottom: 0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  font-size: 1.5rem;
  gap: 2rem;
  justify-content: space-between;
  line-height: 2rem;
  opacity: 0;
  padding: 3rem;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transform: translateX(3rem);
  transition: all 0.2s ease;
  width: 70vw;
  z-index: 110;

  &--open {
    opacity: 1;
    pointer-events: auto;
    transform: translateX(0);
  }
}

.edital-navbar__mobile-links {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.edital-navbar__mobile-link {
  color: $navbar-primary;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  text-decoration: none;

  &--active {
    color: $navbar-secondary;
  }
}

.edital-navbar__mobile-login-link {
  text-decoration: none;
  width: 100%;
}

.edital-navbar__mobile-login {
  background-color: $navbar-primary;
  border: none;
  border-radius: 9999px;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: 500;
  line-height: inherit;
  padding: 0.5rem 1rem;
  width: 100%;
}

@media (min-width: 1024px) {
  .edital-navbar__desktop {
    display: flex;
  }

  .edital-navbar__mobile {
    display: none;
  }
}

@media (max-width: 1023px) {
  .edital-navbar__container {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
</style>
